import { Ref, ComputedRef, ComponentInstance } from '@vue/composition-api';
import { DocumentBrowseInfo, Mode } from '@/renderer/views/preview/compositions/documentBrowserHandler';
import { MediaBrowseInfo } from '@/renderer/views/preview/compositions/mediaBrowserHandler';
import { ImageBrowseInfo } from '@/renderer/views/preview/compositions/imageBrowserHandler';

// 引入工具类
import { SpaceInfo } from '@/renderer/views/preview/compositions/spaceInfo';
import { SMH } from '@/renderer/scripts/smh';
enum QueryFrom {
  Normal,
  // 点击文件进入
  Share,
} // 点击别人分享的文件进入

interface PreviewHandlerInterface {
  vm: ComponentInstance;
  queryFrom: ComputedRef<QueryFrom>;
  routeName: Ref<string>;
  currentFile: Ref<SMH.SpaceFileItemData | null>;
  currentApplyFile: Ref<SMH.FileApplyCheckData | null>;
  currentDirectory: Ref<string>;
  allFileList: Ref<SMH.SpaceFileItemData[]>;
  allFileCount: Ref<number>;
  spaceInfo: Ref<SpaceInfo | null>;
  spaceTag: string;
  spaceId: string;
  documentBrowseInfo: Ref<DocumentBrowseInfo | null>;
  imageBrowseInfo: Ref<ImageBrowseInfo | null>;
  videoBrowseInfo: Ref<MediaBrowseInfo | null>;
  audioBrowseInfo: Ref<MediaBrowseInfo | null>;
  IsUnsupportedFile: ComputedRef<boolean>;
  innerHandler: any;
  isDrawerShow(): boolean;
  toggleDrawer(): void;
  quickPage(): void;
  updateFileList(fileName: string, path: string, previewPage: number): Promise<void>;
  changeDocumentMode(mode: Mode): void;
  saveDocument(): Promise<void>;
}
export { PreviewHandlerInterface, QueryFrom };
